import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ResourcePage from "@/components/common/ResourcePage";
import { PageHeader } from "@/components/common/States";
import { OpportunityPanel } from "@/components/crm/OpportunityPanel";
import { opportunities } from "@/lib/resources";

export default function Opportunities() {
  const [params, setParams] = useSearchParams();
  const [selected, setSelected] = useState(params.get("open"));
  useEffect(() => { if (params.get("open")) setSelected(params.get("open")); }, [params]);
  const close = () => { setSelected(null); if (params.get("open")) setParams({}, { replace: true }); };
  const [reloadKey, setReloadKey] = useState(0);
  return (
    <div data-testid="opportunities-page">
      <PageHeader eyebrow="Pipeline" title="Opportunities"
        description="Commercial opportunities scored separately on fit, buying signal, research confidence and contact readiness." />
      <ResourcePage config={opportunities} onRowClick={(r) => setSelected(r.id)} reloadKey={reloadKey} />
      <OpportunityPanel id={selected} onClose={close} onChanged={() => setReloadKey((k) => k + 1)} />
    </div>
  );
}
